import { Select, Slider, TextField } from '@mui/material';
import styled, { css } from 'styled-components';
import { ChangeVideoBackground } from '@/features/change-video-background';
import TextElement from '@/shared/ui/TextElement';
import ButtonCustom from '@/shared/ui/ButtonCustom';
export const Page = styled.section `
  z-index: 2;
  display: flex;
  ${({ theme }) => css `
    height: calc(100dvh - ${theme.values.header.room.height});
  `}
  align-items: center;
  width: 100%;
  flex-direction: column;
  gap: 32px;
  overflow-y: auto;

  ${({ theme }) => theme.breakpoints.down('lg')} {
    overflow-x: hidden;
  }
`;
export const SettingsWrapper = styled.div `
  display: flex;
  gap: 32px;
  flex-direction: row;
  justify-content: center;
  position: relative;

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    padding: 0px 16px;
    flex-direction: column;
    gap: 16px;
    align-items: center;
  }
`;
export const Settings = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 32px;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: min-content;
    max-width: 100%;
    gap: 16px;
  }
`;
export const ChangeVideoBackgroundButton = styled(ChangeVideoBackground) `
  position: absolute;
  bottom: 4px;
  left: 4px;
`;
export const VideoWrapper = styled.div `
  position: relative;
  width: 282px;
  height: 174px;

  display: flex;
  align-items: center;
  justify-content: center;

  & video,
  & div {
    border-radius: 8px;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    align-self: center;
  }
`;
export const SelectLabel = styled.label `
  ${({ theme }) => css `
    font-size: ${theme.util.pxToRem(18)};
    font-weight: 500;
    color: ${theme.palette.common.white};
  `}

  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 16px;
    line-height: 20px;
  }

  ${({ isBlackText }) => isBlackText &&
    css `
      color: rgba(0, 0, 0, 0.87);
    `}
`;
export const SelectStyled = styled(Select) `
  max-width: min(550px, 100dvw - 16px);
  width: 100dvw;
  height: 44px;

  ${({ theme }) => theme.breakpoints.down('md')} {
    align-self: center;
  }

  ${({ theme, color = 'black' }) => css `
    border: 1px solid ${color === 'error' ? theme.palette.error.main : theme.palette.primary.main};
    background: ${theme.palette.white.main};
  `}
  border-radius: 4px;

  & .MuiOutlinedInput-notchedOutline {
    ${({ theme, color = 'black' }) => css `
      color: ${color === 'error' ? theme.palette.error.main : theme.palette.primary.main};
    `}
  }

  & .MuiSelect-select {
    ${({ theme, color = 'black' }) => css `
      color: ${theme.palette[color].main};
    `}
  }

  & .MuiSelect-icon {
    right: 11px;
  }
`;
export const SelectOutput = styled.div `
  display: flex;
  align-items: center;
  min-width: 115px;
  gap: 9px;
`;
export const PaperContent = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  width: 100dvw;
  max-width: min(633px, calc(100dvw - 16px));
  padding: 32px;

  ${({ theme }) => theme.breakpoints.down(400)} {
    padding: 16px;
  }
`;
export const ButtonWrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-top: -16px;
`;
export const ErrorText = styled.p `
  /* position: absolute;
  bottom: -23px; */
  ${({ theme }) => css `
    color: ${theme.palette.error.main};
    font-size: ${theme.util.pxToRem(16)};
  `}
`;
export const ErrorBox = styled.div `
  /* position: absolute;
  left: 15px;
  top: 37px; */
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;

  ${({ theme }) => css `
    color: ${theme.palette.error.main};
    font-size: ${theme.util.pxToRem(16)};
  `}
`;
export const HeadingBox = styled.div `
  ${({ theme }) => css `
    color: ${theme.palette.white.main};
  `}
`;
export const AgeSelect = styled(Slider) `
  height: 9px;
  padding: 0;
  padding-top: 48px;

  & .MuiSlider-rail {
    color: white;
    opacity: 1;
  }

  & .MuiSlider-track {
    color: #dbb8ff;
  }

  & .MuiSlider-valueLabel {
    top: 0;
    padding: 0;
    font-size: 16px;
    color: white;
    background: none;

    &::before {
      display: 'none';
    }

    & * {
      background: 'transparent';
      color: white;
    }
  }
`;
export const TextFieldStyled = styled(TextField)(({ theme }) => css `
    border-radius: 4px;
    border: 1px solid ${theme.palette.primary.main};
    background: ${theme.palette.white.main};
  `);
export const PageHeader = styled(TextElement) `
  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 20px;
    line-height: 28px;
  }

  ${({ isBlackText }) => isBlackText &&
    `
      color: rgba(0,0,0,0.87);
    `}
`;
export const PageDescription = styled(TextElement) `
  ${({ theme }) => theme.breakpoints.down('md')} {
    font-size: 16px;
    line-height: 20px;
  }

  ${({ isBlackText }) => isBlackText &&
    `
      color: rgba(0,0,0,0.87);
    `}
`;
export const RequestPermissionsPicture = styled.img `
  ${({ theme }) => theme.breakpoints.down(400)} {
    width: 100%;
    object-fit: contain;
  }
`;
export const RequestPermissionsButton = styled(ButtonCustom) `
  width: 100%;
  max-width: 330px;

  ${({ theme }) => theme.breakpoints.down(400)} {
    text-align: center;
  }
`;
export const ErrorContainer = styled.div `
  display: flex;
  flex-direction: column;
  gap: 5px;
  position: relative;
  min-width: 360px;
`;
